import { toast } from "react-toastify";
import cosApi from "./cos.services";
import silApi from "./sil.services";
import { BASE_URL, URL_SIL_ACCOMMODATION_DOCUMENT_FILE_UPDATE } from "./URL";
import { apiPutRequest } from "../../helpers/Requests";
import { roleAccess } from "../../helpers/RolesPermission";
import { USER_ROLE } from "../../Constants/constant";

export const MOVE_ALREADY_IN_DESTINATION = "MOVE_ALREADY_IN_DESTINATION";

/**
 * Single move API endpoint used by the document Move flow (participant, worker, SIL).
 * Mirrors the "Move here" network behavior and is the shared data source for both the
 * Redux move saga and any direct callers (e.g. drag-and-drop).
 */
export async function executeMoveToFolder({
  item,
  itemType,
  targetParentId,
  workerUuid,
  silHomeUuid,
  silent = false,
}) {
  if (!item) {
    const err = new Error("Missing item");
    err.code = "MOVE_INVALID";
    throw err;
  }

  // Note: we intentionally do NOT short-circuit when the item is already in the
  // destination folder. Moving is idempotent on the backend (it just re-sets the
  // same folder), so we let the request through instead of reporting a skip.

  const isSilHome = Boolean(silHomeUuid);
  const isWorker = Boolean(workerUuid) && !isSilHome;

  if (itemType === "folder") {
    if (isSilHome) {
      await silApi.silDocumentFolderMoveApi({
        folder_id: item.id,
        parent_id: targetParentId,
      });
    } else if (isWorker) {
      await cosApi.moveWorkerFolderApi({
        folder_id: item.id,
        parent_id: targetParentId,
      });
    } else {
      await cosApi.moveParticipantFolderApi({
        folder_id: item.id,
        parent_id: targetParentId,
      });
    }
    if (!silent) toast.success("Folder moved successfully");
  } else {
    if (isSilHome) {
      await apiPutRequest(
        `${URL_SIL_ACCOMMODATION_DOCUMENT_FILE_UPDATE}${item.uuid}`,
        {
          folder_structure_id: targetParentId,
        }
      );
    } else {
      const fileRole = roleAccess([USER_ROLE.Sp_Standard_User]) ? "hrm" : "sp";
      const url = isWorker
        ? `${BASE_URL}${fileRole}/file-management/update-worker-document/${item.uuid}`
        : `${BASE_URL}sp/file-management/update-document/${item.uuid}`;
      await apiPutRequest(url, { folder_structure_id: targetParentId });
    }
    if (!silent) toast.success("File moved successfully");
  }
}
